import { DEV_URLS } from '../shared/api/credentials'

export type GtmEvent = Record<string, unknown> & { event?: string }

declare global {
  interface Window {
    dataLayer?: GtmEvent[]
  }
}

const GTM_SCRIPT_ID = 'gtm-script'

const isDevEnvironment = () => import.meta.env.DEV || DEV_URLS.includes(window.location.hostname)

export const initGtm = (gtmId: string) => {
  if (!gtmId || isDevEnvironment() || document.getElementById(GTM_SCRIPT_ID)) {
    return
  }

  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' })

  const script = document.createElement('script')
  script.id = GTM_SCRIPT_ID
  script.async = true
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`
  document.head.insertBefore(script, document.head.firstChild)
}

export const sendGtmEvent = (event: GtmEvent) => {
  window.dataLayer = window.dataLayer ?? []
  window.dataLayer.push(event)
}
